module.exports = __webpack_public_path__ + "img/pic3.214b034f.png";